module.exports = __webpack_public_path__ + "static/media/BoyNeonXRosa_GraceBeck-20.5db043c2.JPG";